module.exports = __webpack_public_path__ + "img/transportation.5ca4c424.jpg";